module.exports = __webpack_public_path__ + "static/assets/9b984a43450cb8173d6886c42201ac53.png";